import React from "react";
import "./MeetOurTeam.css";

const teamMembers = [
  {
    id: 1,
    name: "Muhammad Usman",
    role: "Developer",
    description:
      "Passionate full-stack developer building innovative agri-tech solutions for a smarter agricultural future.",
    image: "/images/usman.png",
    linkedin: "https://www.linkedin.com/in/muhammad-usman-islamian/",
    email: "2021-icp-0780@icp.edu.pk",
    featured: false,
  },
  {
    id: 2,
    name: "Sabahat Ghaznavi",
    role: "Deputy Director IT",
    description:
      "Deputy Director IT at the Agriculture Department, Government of Khyber Pakhtunkhwa.",
    image: "/images/sabahat.webp",
    linkedin: "https://www.linkedin.com/in/sabahat-ghaznavi/",
    email: "sabahat.ghaznavi@yahoo.com",
    featured: true,
  },
];

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.55V9h3.57zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.21 0 22.23 0Z"
    />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M3 5h18a2 2 0 0 1 2 2v1l-11 7L1 8V7a2 2 0 0 1 2-2Zm-2 5.4 10.46 6.66a1 1 0 0 0 1.08 0L23 10.4V19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
    />
  </svg>
);

const LeafIcon = () => (
  <svg viewBox="0 0 48 48" aria-hidden="true">
    <path
      d="M39 7C20 7 8 15 8 29c0 7 5 11 11 10C34 36 39 21 39 7Z"
      fill="currentColor"
    />
    <path
      d="M7 42C14 29 22 21 33 14"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

function TeamCard({ member }) {
  return (
    <article
      className={`team-card ${member.featured ? "team-card-featured" : ""}`}
    >
      {member.featured && (
        <div className="government-badge">
          <span className="badge-icon">✦</span>
          Government Partner
        </div>
      )}

      <div className="profile-wrap">
        <div className="profile-ring">
          <img
            className="profile-image"
            src={member.image}
            alt={member.name}
            loading="lazy"
            onError={(event) => {
              event.currentTarget.style.visibility = "hidden";
            }}
          />
          <div className="profile-fallback" aria-hidden="true">
            {member.name
              .split(" ")
              .map((part) => part[0])
              .slice(0, 2)
              .join("")}
          </div>
        </div>
        <span className="online-indicator" title="Team member" />
      </div>

      <div className="team-card-content">
        <h2>{member.name}</h2>

        <span className="team-role">
          <LeafIcon />
          {member.role}
        </span>

        <p className="team-description">{member.description}</p>

        <div className="team-divider">
          <span />
          <LeafIcon />
          <span />
        </div>

        <div className="team-socials">
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link linkedin-link"
            aria-label={`${member.name} on LinkedIn`}
            title="LinkedIn"
          >
            <LinkedInIcon />
            <span>LinkedIn</span>
          </a>

          <a
            href={`mailto:${member.email}`}
            className="social-link email-link"
            aria-label={`Email ${member.name}`}
            title="Send email"
          >
            <EmailIcon />
            <span>Email</span>
          </a>
        </div>
      </div>
    </article>
  );
}

export default function MeetOurTeam() {
  return (
    <section className="meet-our-team" id="our-team">
      <div className="team-background-glow" aria-hidden="true" />

      <div className="team-container">
        <header className="team-header">
          <div className="header-badge">
            <span className="badge-dot" />
            OUR TEAM
            <span className="badge-dot" />
          </div>

          <h1>
            Meet the <span>Experts</span>
          </h1>

          <p>The people behind smarter agriculture and digital innovation.</p>

          <div className="header-decoration">
            <span />
            <LeafIcon />
            <span />
          </div>
        </header>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>

        <div className="team-cta">
          <div className="cta-icon" aria-hidden="true">
            <EmailIcon />
          </div>

          <div className="cta-copy">
            <h3>Let's grow something great together.</h3>
            <p>Have a project, idea, or collaboration in mind?</p>
          </div>

          <a className="cta-button" href="mailto:info@tarnab.com">
            Contact Us
            <span aria-hidden="true"> ↗</span>
          </a>
        </div>

        <footer className="team-footer">
          <LeafIcon />
          <p>Growing innovation. Empowering agriculture.</p>
          <LeafIcon />
        </footer>
      </div>
    </section>
  );
}
